import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { id: "money-manager-filter-bar" }
const _hoisted_2 = { class: "money-manager-filter" }
const _hoisted_3 = { class: "filter" }
const _hoisted_4 = { class: "sort-filter" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "divider last"
}
const _hoisted_7 = {
  key: 0,
  class: "invest"
}
const _hoisted_8 = { class: "display-as" }
const _hoisted_9 = { class: "display-as-toggle" }

import { NSelect, NButton, NIcon, NInput } from "naive-ui";
import { ref, watch } from "vue";
type listSortBy = {
  label: string;
  value: string;
};

type filters = {
  sort_by: string;
  sort_asc: boolean;
  search: string;
  non_negative_profit?: boolean;
};

interface IProps {
  gridView: boolean;
  investment?: boolean;
  countInvestment?: number;
  listSortBy: listSortBy[];
  filters: filters;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MoneyManagerFilterBar',
  props: {
    gridView: { type: Boolean },
    investment: { type: Boolean },
    countInvestment: {},
    listSortBy: {},
    filters: {}
  },
  emits: ["toggleView", "onFilters"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const sortBy = ref("");
const sortAsc = ref();
const search = ref("");

watch(props, (val) => {
  sortBy.value = val.filters.sort_by;
  sortAsc.value = val.filters.sort_asc;
  search.value = val.filters.search;
});

function setGrid(target) {
  emit("toggleView", target === "grid" ? true : false);
}

function onSortAsc() {
  sortAsc.value = !sortAsc.value;
  onSearch();
}

function onSortBy(event) {
  sortBy.value = event.target.value;
  onSearch();
}

function onSearch() {
  const filter = {
    sort_by: sortBy.value,
    sort_asc: sortAsc.value,
    search: search.value,
  };
  emit("onFilters", filter);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-nowrap" }, "Sort by:", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sortBy).value = $event)),
            name: "sort-by",
            id: "select-input",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (onSortBy($event)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSortBy, (sort) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: sort.value
              }, [
                (_ctx.investment && sort.value === 'name' ? false : true)
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 0,
                      value: sort.value
                    }, _toDisplayString(sort.label), 9, _hoisted_5))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 544), [
            [_vModelSelect, sortBy.value]
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(NButton), {
            size: "tiny",
            circle: "",
            color: "#00CF47",
            onClick: onSortAsc
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(NIcon), null, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa-solid", sortAsc.value ? 'fa-arrow-down' : 'fa-arrow-up'])
                  }, null, 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (!_ctx.investment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.investment)
        ? (_openBlock(), _createBlock(_unref(NInput), {
            key: 0,
            value: search.value,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
            round: "",
            size: "medium",
            style: {"--n-color":"none","--n-color-focus":"none","--n-border":"1px solid white","--n-border-focus":"1.5px solid white","--n-text-color":"white","--n-caret-color":"white"},
            placeholder: "Search Manager...",
            onChange: onSearch
          }, {
            suffix: _withCtx(() => [
              _createVNode(_unref(NIcon), { color: "white" }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "fa-solid fa-magnifying-glass" }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.investment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_font_awesome_icon, {
            class: "icon",
            icon: ['fas', 'dollar-sign']
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.countInvestment) + " / 5 Investment", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _cache[9] || (_cache[9] = _createElementVNode("p", null, "Display As", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "divider" }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["display-toggle", { active: _ctx.gridView }]),
          role: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setGrid('grid')))
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("img", {
            src: "/assets/img/show-grid-icon.svg",
            alt: "show-grid"
          }, null, -1)
        ]), 2),
        _createElementVNode("div", {
          class: _normalizeClass(["display-toggle", { active: !_ctx.gridView }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setGrid('table')))
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("img", {
            src: "/assets/img/show-table-icon.svg",
            alt: "show-table"
          }, null, -1)
        ]), 2)
      ])
    ])
  ]))
}
}

})